<div class="lubricant-wrapper" [formGroup]="form">
    <div class="row">
        <div class="col-4">
            <mat-label
                class="mat-label-general lubricant-wrapper"
                [ngbTooltip]="lubricant_tooltip"
                container="body"
                placement="right"
                tooltipClass="custom-tooltip"
            >
                <!-- Lubricants -->
                {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.LUBRICANT' | transloco }}
            </mat-label>
            <ng-template #lubricant_tooltip>
                <p>
                    {{ 'TOOLTIP.INFORMATE_CALC_LABELS.LUBRICANTS' | transloco }}
                </p>
            </ng-template>
        </div>
        <div class="col-8 informate_select_wrapper">
            <mat-select
                name="lubricants"
                class="lubricant-select input-select"
                [class.spinner]="loading"
                formControlName="lubricant"
                matTooltip="Lubricant is Required"
                [matTooltipDisabled]="form.get('lubricant').valid"
                [class.select-disable]="enable"
            >
                <mat-option class="option-list" *ngFor="let lubricant of lubricantList" [value]="lubricant.lubricantId">
                    {{ lubricant.lubricantName }}
                </mat-option>
            </mat-select>
            <div class="row">
                <div class="col-md-6">
                    <ng-container>
                        <input
                            matInput
                            type="number"
                            class="lubricant-class lubricantValue-wrapper input-form-class"
                            formControlName="lubricantValue"
                            name="unit_value"
                            #tooltip="matTooltip"
                            matTooltip="K Factor must be within range 0.01 - 0.99"
                            [matTooltipDisabled]="form.get('lubricantValue').valid"
                            [ngClass]="form.get('lubricantValue').valid ? '' : 'highLight'"
                            [readonly]="this.form.get('lubricantType').value == 0"
                            [class.select-disable]="enable"
                            (keydown)="disableArrowKeys($event)"
                            (wheel)="disableScroll($event)"
                        />
                    </ng-container>
                </div>
                <div class="col-md-6 lubricant-type-drop informate_select_wrapper">
                    <ng-container>
                        <mat-select formControlName="lubricantType" name="unit_lubricant" class="lubricant-select" [class.select-disable]="enable">
                            <mat-option class="option-list" *ngFor="let lt of lubricantTypeList | keyvalue" [value]="lt.key">{{ lt.value }}</mat-option>
                        </mat-select>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
